exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-lists .img-box[data-v-6ddba1c3] {\n  padding: 0 15px;\n  width: 100%;\n  min-height: 100px;\n  overflow: hidden;\n  margin-top: -3px;\n}\n.item-lists .img-box .el-icon-picture[data-v-6ddba1c3] {\n  width: 100%;\n  height: 100px;\n  display: block;\n  line-height: 100px;\n  text-align: center;\n}\n.item-lists > div:nth-child(2n) .el-icon-picture[data-v-6ddba1c3] {\n  background-color: #dcdfea;\n}\n", ""]);

// exports
